import { Icon } from 'components/ui/Icon'

type Props = {
  visible?: boolean
}

export const ChatBotAvatar = ({ visible }: Props) => {
  return (
    <div
      className={`tw-flex tw-items-center tw-justify-center tw-h-10 tw-w-10 tw-rounded-full tw-shrink-0 ${visible ? '' : 'tw-hidden'}`}
      style={{
        border: '0.5px solid var(--border-default)',
      }}
    >
      <Icon icon={['far', 'message-bot']} className="tw-h-4 tw-w-4" style={{ color: 'var(--icon-default)' }} />
    </div>
  )
}
